export const formatMessageTime = (timestamp: string | Date, now?: Date): string => {
  const messageDate = new Date(timestamp);
  const nowDate = now ?? new Date();

  // Check if the message is from today
  const isToday = messageDate.toDateString() === nowDate.toDateString();

  if (isToday) {
    // Format as HH:mm for today's messages
    return messageDate.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit', // TODO: Make it optional from the config
      hour12: false
    });
  } else {
    // Format as DD/MM/YYYY HH:mm for other days
    return messageDate.toLocaleString([], {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit', // TODO: Make it optional from the config
      hour12: false
    });
  }
};

export const formatSessionDateTime = (date: Date): string => {
  const dateStr = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });

  const timeStr = date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });

  return `${dateStr} ${timeStr}`;
};

export const dateReviver = (value: string | Date): Date => {
  if (typeof value === 'string') {
    return new Date(value);
  }
  return value as Date;
};
